import { render, staticRenderFns } from "./TransfClient.vue?vue&type=template&id=9582a5b0"
import script from "./TransfClient.vue?vue&type=script&lang=js"
export * from "./TransfClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports